import { apiQuery, deleteCommand, findOneCommand, updateCommand, queueQuery, bulkManipulate } from './templates';
import * as _ from 'underscore';
import moment from 'moment-timezone';
import MonacoEditorComponent from './components/MonacoEditor';
import async from 'async';
import * as beautify_js from 'js-beautify';
const bhtml = beautify_js.html;
const bcss = beautify_js.css;
const bjs = beautify_js;
import feather from 'feather-icons';
import { format } from "prettier/standalone";
import * as prettierPluginBabel from "prettier/plugins/babel";
import * as prettierPluginEstree from "prettier/plugins/estree";
import swal from 'sweetalert2';
import 'angular-ui-ace';
export default angular.module('obto.data.scriptconsole', ['ui.ace'])
    .controller('scritpConsoleFormController', ['$scope', '$http', '$rootScope', '$log', 'scriptConsole', '$timeout', '$window', '$routeParams', '$anchorScroll', '$location', '$uibModal', 'API', '$localstorage', 'ScriptLoader', '$route', '$ngRedux', function ($scope, $http, $rootScope, $log, scriptConsole, $timeout, $window, $routeParams, $anchorScroll, $location, $uibModal, API, $localstorage, ScriptLoader, $route, $ngRedux) {

        $scope._output = "<span/>";
        $scope.service = scriptConsole;
        $scope.printoutput = "";
        let error = false;

        $scope.editorTheme = $localstorage.getObject("ob.props")['co.obto.editor.theme'] || "chaos";

        let _format = $rootScope.globalAttributes['co.obto.domain.datetime.format'];
        let i = 0, editor;
        const ob = {
            root: $rootScope,
            scope: $scope,
            timeout: $timeout,
            $route,
            http: $http,
            window: $window,
            moment: moment,
            _: _,
            routeParams: $routeParams,
            async: async,
            beautify: bjs,
            scrollTo: $anchorScroll,
            location: $location,
            modal: $uibModal,
            API: API,
            localStorage: $localstorage,
            swal: swal,
            M: ScriptLoader
        };

        $scope.currentMode = 1;

        $scope.clearconsole = function () {

            let myEl = angular.element(document.querySelector('#logthis'));
            myEl.html("");
        };

        // $scope.$watch("service.getData()", function (n, o) {
        //     let myEl = angular.element(document.querySelector('#logthis'));
        //     myEl.append(moment.tz($rootScope.timezone).format(_format) + " : " + n.txt + '<br/>');
        // }, true);

        $scope.setTemplate = async function (t) {

            let tmp = "";
            let newPosition = 1;

            if (editor.getCursorPosition() !== 1) {
                newPosition = editor.getCursorPosition() + 1;
            }

            switch (t) {
                case 1:
                    tmp = await format(apiQuery, {
                        parser: "babel",
                        plugins: [prettierPluginBabel, prettierPluginEstree],
                        jsxBracketSameLine: true
                    });
                    editor.session.insert(editor.getCursorPosition(), tmp);
                    break;

                case 5:
                    tmp = await format(deleteCommand, {
                        parser: "babel",
                        plugins: [prettierPluginBabel, prettierPluginEstree],
                        jsxBracketSameLine: true
                    });
                    editor.session.insert(editor.getCursorPosition(), tmp);
                    break;

                case 6:
                    tmp = await format(findOneCommand, {
                        parser: "babel",
                        plugins: [prettierPluginBabel, prettierPluginEstree],
                        jsxBracketSameLine: true
                    });
                    editor.session.insert(editor.getCursorPosition(), tmp);
                    break;

                case 7:
                    tmp = await format(updateCommand, {
                        parser: "babel",
                        plugins: [prettierPluginBabel, prettierPluginEstree],
                        jsxBracketSameLine: true
                    });
                    editor.session.insert(editor.getCursorPosition(), tmp);
                    break;

                case 8:
                    tmp = await format(queueQuery, {
                        parser: "babel",
                        plugins: [prettierPluginBabel, prettierPluginEstree],
                        jsxBracketSameLine: true
                    });
                    editor.session.insert(editor.getCursorPosition(), tmp);
                    break;

                case 9:
                    tmp = await format(bulkManipulate, {
                        parser: "babel",
                        plugins: [prettierPluginBabel, prettierPluginEstree],
                        jsxBracketSameLine: true
                    });
                    editor.session.insert(editor.getCursorPosition(), tmp);
                    break;

                case 10:
                    tmp = await format(bulkManipulate, {
                        parser: "babel",
                        plugins: [prettierPluginBabel, prettierPluginEstree],
                        jsxBracketSameLine: true
                    });
                    editor.session.insert(editor.getCursorPosition(), tmp);
                    break;

                case 11:
                    tmp = await format(bulkManipulate, {
                        parser: "babel",
                        plugins: [prettierPluginBabel, prettierPluginEstree],
                        jsxBracketSameLine: true
                    });
                    editor.session.insert(editor.getCursorPosition(), tmp);
                    break;


                default:
                    editor.session.insert(editor.getCursorPosition(), "");

            }

        };

        $scope.format = async function () {

            let script = editor.getSession().getValue();
            let formatted = "";

            if ($scope.currentMode === 1) {
                formatted = await format(script, {
                    parser: "babel",
                    plugins: [prettierPluginBabel, prettierPluginEstree],
                    jsxBracketSameLine: true
                });
            }

            if ($scope.currentMode === 2) {

                formatted = await format(script, {
                    parser: "babel",
                    plugins: [prettierPluginBabel, prettierPluginEstree],
                    jsxBracketSameLine: true
                });

                editor.getSession().setValue(formatted);
                return;
            }

            if ($scope.currentMode === 3) {
                formatted = bhtml(script, {
                    indent_size: 2,
                    indent_char: " "
                });

            }

            if ($scope.currentMode === 4) {
                formatted = bcss(script, {
                    indent_size: 2,
                    indent_char: " "
                });
            }

            editor.getSession().setValue(formatted);


        };

        $scope.foldAll = function () {
            editor.getSession().foldAll();
        };

        $scope.unfold = function () {
            editor.getSession().unfold();
        };

        $scope.appMode = function (m) {
            if (m === 1) {
                $scope.currentMode = 1;
                editor.getSession().setMode("ace/mode/javascript");
            }

            if (m === 2) {
                editor.getSession().setMode("ace/mode/jsx");
                $scope.currentMode = 2;
            }

            if (m === 3) {
                editor.getSession().setMode("ace/mode/html");
                $scope.currentMode = 3;
            }

            if (m === 4) {
                editor.getSession().setMode("ace/mode/css");
                $scope.currentMode = 4;
            }
        };

        $scope.editorView = { 'height': '653px' };

        let funcStart = "return function(o){";
        let funcEnd = "};";

        $scope.runScript = function () {
            new Function(funcStart + editor.getSession().getValue() + funcEnd)()(ob);
        };

        $scope.submitForm = function () {

            swal({
                title: "Are you sure?",
                text: "You gotta do what you gotta do",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "Yes, run it!",
                cancelButtonText: "Abort plz!"
            }).then((result) => {
                if (result.value) {
                    const request = $http({
                        method: "post",
                        url: "/o/script_console.bto",
                        data: {
                            script: editor.getSession().getValue(),
                            _csrf: $scope._csrf
                        }
                    });

                    // Store the data-dump of the FORM scope.
                    request.then(
                        function (response) {
                            if (response.status === 200) {
                                if (response.data.success) {
                                    editor.getSession().setValue(response.data.lastscript);

                                    $localstorage.setObject("ob.lastscript", {
                                        value: response.data.lastscript
                                    });

                                    $.notify({
                                        title: '<strong>Success!</strong>',
                                        message: 'Script Executed.'
                                    }, {
                                        placement: {
                                            from: "bottom",
                                            align: "right"
                                        },
                                        allow_dismiss: false,
                                        type: 'minimalist',
                                        delay: 4000,
                                        icon_type: 'image',
                                        template: '<div data-notify="container" class="col-xs-11 col-sm-3 alert alert-{0}" role="alert">' +
                                            '<img data-notify="icon" class="img-circle pull-left">' +
                                            '<span data-notify="title">{1}</span>' +
                                            '<span data-notify="message">{2}</span>' +
                                            '</div>'
                                    });

                                }
                            }

                        });
                } else {
                    swal("Cancelled", "Execution aborted!", "error");
                }

            });
        };
        $scope.input = {
            lastScript: $localstorage.getObject("ob.lastscript").value || ""
        }

        $scope.reactComponent = MonacoEditorComponent;

        // setInterval(()=>{
        //     $ngRedux.dispatch({
        //         type: 'INCREMENT_COUNTER'
        //     });
        // }, 3000);
        feather.replace({
            width: 18,
            height: 18,
        });
    }]);
